import { Box, Typography, useTheme } from '@mui/material';
import Checkbox from '../Checkbox';
import TextButton from '../TextButton';
import Button from '../Button';
import { getThemeColors } from '../../helpers/themeStyles';

const DriversFooterRow = ({ data, onGiveBonus, onRemove }) => {
  const theme = useTheme();
  const colors = getThemeColors(theme);

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '100%',
        backgroundColor: colors.footerBg,
        color: colors.textPrimary,
        boxSizing: 'border-box',
        padding: '0px 24px',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
        <Checkbox checked />
        <Typography sx={{ fontSize: 20, fontWeight: 700 }}>
          {data?.size ?? 0} sélectionné(s)
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <TextButton onClick={onRemove}>Tout supprimer</TextButton>
        {onGiveBonus ? (
          <Button variant="contained" onClick={onGiveBonus}>
            Donner un bonus
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};

export default DriversFooterRow;
